import { tokens as tamaguiTokens } from "@tamagui/themes";

export const tokens = {
  ...tamaguiTokens,
  color: {
    ...tamaguiTokens.color,
    deltaBlue: "#0072C6",
    darkBackground: "#161616",
    cardBackground: "#252525",
    pillBackground: "#FFFFFF16",
    goodGreen: "#4CAF50",
    successGreen: "#1CC83A",
    successGreenAlpha20: "#1CC83A20",
    energyRed: "#D32F2F",
    energyRedAlpha20: "#D32F2F20",
    error: "#F43C3F",
    hvacOrange: "#FF9800",
    topUsageColor1: "#42BCFF",
    topUsageColor2: "#3E34E5",
    topUsageColor3: "#DC208E",
    topUsageColor4: "#FD685E",
    topUsageColor5: "#FFB449",
    textLight: "#FFFFFF",
    textSecondary: "#9E9E9E",
    hgPrimary: "#1C91E2",
    hgSecondary: "#04436F",
    hgTertiary: "#C4F042",
    transparentBorder: "#FFFFFF0D",
    info: "#70BBF7",
    infoBackground: "#FFFFFF08",
    white: "#FFFFFF",
    white1: "#FFFFFF00",
    white2: "#FFFFFF1F",
    white3: "#FFFFFF09",
    white4: "#FFFFFF0E",
    white5: "#FFFFFF17",
    white6: "#FFFFFF20",
    white7: "#FFFFFF2D",
    white8: "#FFFFFF3F",
    white9: "#FFFFFF62",
    white10: "#FFFFFF72",
    white11: "#FFFFFF96",
    white12: "#FFFFFFEB",
    white40: "#FFFFFF40",
    color12: "#ECEDEE",
    darkBackgroundGradient: "#2A2A2A",
    warning: "#FF8600",
    warningAlpha20: "#FF860020",
    gradientGoodStart: "#2A2A2A",
    gradientGoodEnd: "#161616",
    gradientPoorStart: "#823F12",
    gradientPoorEnd: "#170B03",
    gradientErrorStart: "#6E2123",
    gradientErrorEnd: "#170B03",
    gradientInfoStart: "#1C91E2",
    gradientInfoEnd: "#04214D",
    gradientSuccessStart: "#0E621D",
    gradientSuccessEnd: "#0B1703",
    gradientSuccessCheckmarkStart: "#BCD1E01A",
    gradientSuccessCheckmarkEnd: "#0000001A",
    gradientNeutralStart: "#2A2A2A",
    gradientNeutralEnd: "#161616",
    neutral: "#555555",
    gray1: "#161616",
    gray2: "#1C1C1C",
    gray3: "#232323",
    gray4: "#282828",
    gray8: "#505050",
    gray9: "#707070",
    glowOrange: "#FF8600",
    glowRed: "#FF0000",
    humidityGlowWarning: "#C9450D",
    humidityGradientWarningStart: "#F67123",
    humidityGradientWarningEnd: "#B12C00",
    humidityGlowCritical: "#C91917",
    humidityGradientCriticalStart: "#FF504A",
    humidityGradientCriticalEnd: "#B10000",
    transparent: "transparent",
    weatherOrangeOpaque: "#FFB029",
    weatherOrange: "#FFB02940",
    weatherBlue: "#1C91E233",
    warningRed: "#EB383A",
    warningRedAlpha20: "#EB383A20",
    waterGradientStart: "#69BAF1",
    waterGradientEnd: "#0A4C79",
    statsGradientEnd: "#106FB0",
    qrScanOverlay: "#FFFFFFCC",
    instructionsGradientStart: "#2A2A2A",
    instructionsGradientEnd: "#161616",
    instructionsHeaderBackground: "#0000001D",
    formInputBackground: "#1c1c1c",
    formInputBorder: "#707070",
    loaderColor1: "#353535",
    loaderColor2: "#4E4E4E",
    errorScreenImageBorder: "#353535",
    errorScreenImageGradientStart: "#2A2A2A",
    errorScreenImageGradientEnd: "#161616",
    hgPrimaryGradientStart: "#1C91E2",
    hgPrimaryGradientEnd: "#106FB0",
    sensorInfoGradientStart: "#222C34",
    sensorInfoGradientEnd: "#161616",
    sensorLocationGradientStart: "#2A2A2A",
    sensorLocationGradientEnd: "#161616",
    circuitDetectedGradientStart: "#2A2A2A",
    circuitDetectedGradientEnd: "#1C2D1F",
    widgetCardGradientStart: "#2A2A2A",
    widgetCardGradientEnd: "#161616",
    black: "#000000",
    black2: "#000000e8",
    black12: "#000000E8",
  },
};

// IMPORTANT: Tamagui expects all values inside the `color` token to be strings (e.g., hex, rgba, etc.).
// Nested objects or arrays (like gradients) will break the static extraction and cause build-time errors.
// To avoid this, we extract gradient definitions into a separate `gradients` constant
// instead of including them in `tokens.color`.
export const gradients = {
  success: ["#3C984C", "#1CC83A", "#0B3713"],
  warning: ["#FF8600", "#FF8600", "#FF8600"],
  error: ["#560D0D", "#F12729", "#982F2F"],
  blue: ["#00254D", "#1C91E2", "#47D1FF"],
  gray: ["#2A2A2A", "#666666", "#999999"],
};
